import { partfinitiClient } from 'core/services';

export const createFromQuote = async (data) =>
  (await partfinitiClient.postForm('/order/vendor/create-from-quote', data)).cliJob;
